import { Component, OnInit } from '@angular/core';
import {MatDialogRef} from '@angular/material/dialog';
import {HttpService} from '../../../services/http.service';
import {environment} from '../../../../environments/environment';
import {ToastService} from '../../../services/toast.service';

@Component({
  selector: 'app-ai-replace-dialog',
  templateUrl: './ai-replace-dialog.component.html',
  styleUrls: ['./ai-replace-dialog.component.scss']
})
export class AiReplaceDialogComponent implements OnInit {

  public totalProducts: number = 0;
  public from = '';
  public to = '';
  public limit: number = 1000;
  public checkData = [];
  public disable = false;
  constructor(
    private dialogRef: MatDialogRef<AiReplaceDialogComponent>,
    private httpService: HttpService,
    private toastService: ToastService,
  ) { }

  ngOnInit(): void {
  }

  onCheck() {
    this.httpService.post(environment.API_PATH + '/ai/replaceFromToCheck', {
      from: this.from,
      to: this.to,
      limit: this.limit
    }).subscribe(res => {
      this.checkData = res;
      this.totalProducts = res.length;
    });
  }

  onSubmit() {
    if (this.from.length === 0 || this.to.length === 0) {
      alert('Find or Replace in empty');
    }
    if (confirm('Are you sure?')) {
      this.disable = true;
      this.httpService.post(environment.API_PATH + '/ai/replaceFromTo', {
        from: this.from,
        to: this.to,
        limit: this.limit
      }).subscribe(res => {
        this.totalProducts = res.total;
        this.toastService.info('Please wait...');
        setTimeout(() => {
          this.dialogRef.close();
        }, 2000);
      });
    }
  }

  protected readonly Object = Object;
  protected readonly Number = Number;
}
